export type ProductLine = {
  productLine: ProductLineType;
  features: FeatureSection[];
  info: ProductLineInfo;
  name: string;
  price: ProductLinePrice;
  detailedCoverages?: DetailedCoverage[];
  campaign?: Campaign;
};

export type ProductLineType = {
  value: string;
  id: string;
};

export type FeatureSection = {
  name: string;
  list: Feature[];
  label: string;
};

export type Feature = {
  name: string;
  available?: boolean;
  label: string;
};

export type ProductLineInfo = {
  description: string;
  coverageDescription: string;
  isRecommended: boolean;
};

export type ProductLinePrice = {
  default: string;
  halfYearlyPrice?: string;
  quarterlyPrice?: string;
  currency: string;
  frequency: string;
  oldPrice?: string;
  savingAmount?: string;
};

export type DetailedCoverage = {
  id: string;
  label: string;
  price: string;
};

export type Campaign = {
  campaignText: string;
  campaignTeaser: string;
};
